

























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import { Style, CSS } from "@/services/styles/types";
import { BehaviorEnum, RecurenceEnum } from "@/services/posts/types";
import { RenderPostModel } from "@/services/render/types";
import {
    getStyle,
    createStyle,
    updateStyle
} from "@/services/styles/stylesService";
import {
    GetLocalizedStyleableTypes,
    styleComponents,
    styleSufix,
    renderComponents,
    renderSufix
} from "@/components/posts/PostTypeRegister";
import { Meeting, Scheduling } from "@/services/posts/postTypes/meetingList";
import { MomentFormat, DatePostProperties, DateStyle, CapitalizeEnum } from "@/services/posts/postTypes/date";
import ImageStyle from "@/components/posts/image/ImageStyle.vue";
import VideoStyle from "@/components/posts/video/VideoStyle.vue";
import { ClockPostProperties } from "@/services/posts/postTypes/clock";
import FolderStyle from "@/components/posts/folder/FolderStyle.vue";
import HtmlStyle from "../posts/html/HtmlStyle.vue";
import FixedHtmlStyle from "../posts/fixedHtml/FixedHtmlStyle.vue";
import UnsavedFormModal from "@/components/common/modals/UnsavedFormModal.vue";
import { bus } from "@/bus";
import { settingsValidators } from "@/components/styles/validators";
import validate from "@/directives/validate";
import { validateForm } from "@/services/validation/validationService";
import WayfinderStyle from "../posts/wayfinder/WayfinderStyle.vue";
import { FixedHtmlProperties } from "@/services/posts/postTypes/fixedhtml";

@Component<StyleForm>({
    beforeRouteLeave(to, from, next) {
        this.onBeforeRouteLeave(to, next);
    },
    components: {
        ...styleComponents,
        ...renderComponents,
        UnsavedFormModal
    },
    filters: {
        style(value: string) {
            if (value === undefined || value === "") return "";
            else {
                return value.concat(styleSufix);
            }
        },
        render(value: string) {
            return value.concat(renderSufix);
        }
    },
    directives: {
        validate
    }
})
export default class StyleForm extends Vue {
    @Prop() private styleId!: string;

    style = {
        id: "",
        name: "",
        postType: "",
        css: {} as CSS
    } as Style;

    // used for comparing if form have changes
    priorStyleState = JSON.parse(JSON.stringify(this.style)) as Style;

    validators = settingsValidators;

    @Watch("style.css", { deep: true }) t() {
        this.cleanFixed();
    }

    nextRoute = "";
    saveClicked = false;
    continue = false;
    fetchingActive = false;
    bgColor = "#ffffff";
    fixedError = false;
    timeout = 0;
    routeParams = {};

    // TODO dummy conent

    dummyItems = {
        Html: {
            id: "",
            postType: "",
            properties: {
                showTime: 100,
                html: "This is what your style will look like"
            },
            css: {} as HtmlStyle,
            styleId: "",
            channelId: "",
            channelName: "",
            name: "",
            originalId: ""
        } as RenderPostModel,
        FixedHtml: {
            id: "",
            postType: "",
            properties: {
                showTime: 100,
                contentTemplateId: "",
                contentTemplate: "<div>This is a plain-text with your Styles applied</div>",
                data: []
            } as FixedHtmlProperties,
            css: {} as FixedHtmlStyle,
            styleId: "",
            channelId: "",
            channelName: "",
            name: "",
            originalId: ""
        } as RenderPostModel,
        RSS: {
            id: "",
            settings: {},
            postType: "",
            properties: {
                channelName: "This is the rss channel title",
                channelDescription: "This is the rss channel description",
                itemTitle: "This is rss item title",
                itemDescription: "This is rss item description"
            },
            css: {},
            styleId: "",
            channelId: "",
            channelName: "",
            name: "",
            originalId: ""
        } as RenderPostModel,
        MeetingList: {
            id: "id1",
            postType: "",
            properties: {
                titleAllDayMeetings: "Title for all day meetings",
                meetings: [],
                renderMeetings: [{
                    id: "id2",
                    headline: "Meeting Headline",
                    description: "Meeting Description",
                    scheduling: {
                        fromDate: "2020-02-27T02:00:00+01:00",
                        toDate: "2020-02-27T02:00:00+01:00",
                        fromTime: "2020-02-27T01:00:00+01:00",
                        toTime: "2020-02-27T02:00:00+01:00",
                        allDay: true,
                        neverending: false,
                        recurenceType: RecurenceEnum.daily,
                        recurenceValues: [],
                        yearly: ""
                    } as Scheduling
                },
                {
                    id: "id3",
                    headline: "Meeting Headline 2",
                    description: "Meeting Description 2",
                    scheduling: {
                        fromDate: "2020-02-27T02:00:00+01:00",
                        toDate: "2020-02-27T02:00:00+01:00",
                        fromTime: "2020-02-27T01:00:00+01:00",
                        toTime: "2020-02-27T02:00:00+01:00",
                        allDay: false,
                        neverending: false,
                        recurenceType: RecurenceEnum.daily,
                        recurenceValues: [],
                        yearly: ""
                    } as Scheduling
                }] as Array<Meeting>
            },
            css: {},
            styleId: "",
            channelId: "",
            channelName: "",
            name: "",
            originalId: ""
        } as RenderPostModel,
        Date: {
            id: "",
            postType: "",
            properties: {
                dateFormat: {
                    textOne: "",
                    textTwo: "",
                    textThree: "-",
                    textFour: "-",
                    textFive: "",
                    dateOptionOne: { format: "", capitalize: CapitalizeEnum.Locale },
                    dateOptionTwo: { format: "DD", capitalize: CapitalizeEnum.Locale },
                    dateOptionThree: { format: "MM", capitalize: CapitalizeEnum.Locale },
                    dateOptionFour: { format: "YYYY", capitalize: CapitalizeEnum.Locale }
                } as MomentFormat,
                language: "",
                format: ""
            } as DatePostProperties,
            css: {} as DateStyle,
            styleId: "",
            channelId: "",
            channelName: "",
            name: "",
            originalId: ""
        } as RenderPostModel,
        Image: {
            id: "",
            postType: "",
            properties: {
                caption: "Image Caption"
            },
            css: {} as ImageStyle,
            styleId: "",
            channelId: "",
            channelName: "",
            name: "",
            originalId: "",
            settings: {
                showTime: 100,
                behavior: BehaviorEnum.letterBox
            }
        } as RenderPostModel,
        Video: {
            id: "",
            postType: "",
            properties: {
                caption: "Video Caption"
            },
            css: {} as VideoStyle,
            styleId: "",
            channelId: "",
            channelName: "",
            name: "",
            originalId: "",
            settings: {}
        } as RenderPostModel,
        Clock: {
            id: "",
            postType: "",
            properties: {
                clockFormat: {
                    textOne: "",
                    textTwo: "",
                    textThree: ":",
                    textFour: "",
                    textFive: "",
                    clockOptionOne: "",
                    clockOptionTwo: "HH",
                    clockOptionThree: "mm",
                    clockOptionFour: ""
                },
                format: "",
                timeZone: "localtime"
            } as ClockPostProperties,
            css: {} as DateStyle,
            styleId: "",
            channelId: "",
            channelName: "",
            name: "",
            originalId: ""
        } as RenderPostModel,
        Folder: {
            id: "",
            postType: "",
            properties: {
                caption: "Folder Post Caption"
            },
            css: {} as FolderStyle,
            styleId: "",
            channelId: "",
            channelName: "",
            name: "",
            originalId: "",
            settings: {}
        } as RenderPostModel,
        Wayfinder: {
            id: "",
            postType: "",
            properties: {
                wayfinderId: ""
            },
            css: {} as WayfinderStyle,
            styleId: "",
            channelId: "",
            channelName: "",
            originalId: "",
            name: ""
        } as RenderPostModel
    };

    fetchData() {
        if (this.styleId) {
            this.fetchingActive = true;
            getStyle(this.styleId).then((response: Style) => {
                this.style = response;
                bus.$emit("documentTitle", this.style.name);
                this.priorStyleState = JSON.parse(JSON.stringify(this.style));
                this.checkStyle();
                this.fetchingActive = false;
            });
        }
    }

    // lifecycle hooks
    created() {
        this.initializeStyleId();
        this.fetchData();
    }

    // computed
    get localizedItemTypes() {
        return GetLocalizedStyleableTypes();
    }

    get editMode() {
        return this.styleId !== undefined;
    }

    // metods
    initializeStyleId() {
        if (!this.styleId) {
            this.styleId = this.$route.params.styleId;
        }
    }

    setValueData(data: CSS) {
        this.style.css = data;
    }

    cleanFixed() {
        for (const c in this.style.css) {
            if ((this.style.css as any)[c].toLowerCase().includes("fixed")) {
                this.fixedError = true;
                (this.style.css as any)[c] = (this.style.css as any)[c].replace(/fixed/gi, "absolute");
            }
        }
        if (this.fixedError) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.fixedError = false;
            }, 10000);
        }
    }

    checkStyle() {
        for (const c in this.style.css) {
            const style = (this.style.css as any)[c].toLowerCase();
            const dummy = document.createElement("div");
            dummy.style.cssText = style;
            const color = dummy.style.color;
            if (color !== null && color !== "") {
                if (color === "white") this.bgColor = "#999999";
                else {
                    const match = color.match(/rgba?\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)?(?:, ?(\d(?:\.\d?))\))?/);
                    const colors = match ? {
                        red: match[1],
                        green: match[2],
                        blue: match[3]
                    } : {};
                    if (colors === {}) return;
                    const lum = 0.2126 * Number(colors.red) + 0.7152 * Number(colors.green) + 0.0722 * Number(colors.blue);
                    if (lum > 220) this.bgColor = "#999999";
                }
            }
        }
    }

    clearValue() {
        this.style.css = {} as CSS;
    }

    onBeforeRouteLeave(to: Route, next: any) {
        if (this.saveClicked || this.continue || this.fetchingActive) {
            next();
        } else {
            this.nextRoute = to.name ? to.name : "";
            this.routeParams = to.params;
            const noChanges = this.lodash.isEqual(this.priorStyleState, this.style);
            if (noChanges) {
                next();
            } else {
                next(false);
                (this.$refs.UnsavedFormModal as any).open();
            }
        }
    }

    onContinue(data: boolean) {
        this.continue = data;
        if (data) this.$router.push({ name: this.nextRoute, params: this.routeParams });
        this.nextRoute = "";
    }

    changeBackground() {
        if (this.bgColor === "#ffffff") this.bgColor = "#999999";
        else this.bgColor = "#ffffff";
    }

    // header buttons
    back() {
        window.history.go(-1);
    }

    // footer buttons
    async save(evt: any) {
        this.saveClicked = true;
        if (!await validateForm([this.validators])) return;
        this.cleanFixed();
        if (!this.editMode) {
            createStyle(this.style).then(() => {
                this.$router.push({ name: "styles" });
            });
        } else {
            updateStyle(this.style).then(() => {
                this.$router.push({ name: "styles" });
            });
        }
    }
}
